module.exports = __webpack_public_path__ + "static/media/image_27.9d54e3a0.png";